import { Drawing } from "drawing";
import { multiplier } from "../utilities/scales.js";

function shapeOverlay(item, { dragging } = { dragging: false }) {
  const swf = item.cache.shapeWithFeatures;
  const { xmin, ymin, width, height } = item.cache.bbox;

  if (!item.drawing?.clip?.drawing_scale) return null;

  const m = multiplier(item.drawing.clip.drawing_scale);
  const scale = 300 / m;
  const x = (item.drawing.clip.drawing_offset?.x || 0) * scale;
  const y = (item.drawing.clip.drawing_offset?.y || 0) * scale;
  const rx = item.drawing.clip.x;
  const ry = -item.drawing.clip.y - item.drawing.clip.height;

  let annotations;
  if (item.data.reference_planes?.type === "grid") {
    const xoff =
      item.data.reference_planes.x_offset?.value.toNumber("inches") || 0;
    let vers = [xoff];
    let v = xoff;
    item.data.reference_planes.vertical?.forEach((vgl) => {
      const val = vgl.value.toNumber("inches");
      v += val;
      vers.push(v);
    });

    const yoff =
      item.data.reference_planes.y_offset?.value.toNumber("inches") || 0;
    let hors = [yoff];
    let h = yoff;
    item.data.reference_planes.horizontal?.forEach((hgl) => {
      const val = hgl.value.toNumber("inches");
      h += val;
      hors.push(h);
    });

    const rows = hors.length - 1;
    const a = [
      ...vers.map((x, i) => {
        let d = new Drawing();
        if (item.data.reference_planes.merges) {
          let y = 0;
          for (let j = 0; j < hors.length - 1; j++) {
            const wallLeft =
              item.cache.mergeStore?.hasWallLeft(rows - j - 1, i) ?? true;
            if (wallLeft) {
              d = d.polyline([
                { x, y },
                { x, y: hors[j + 1] },
              ]);
              y = hors[j + 1];
            } else {
              y = hors[j + 1];
            }
          }
        } else {
          d = d.polyline([
            { x, y: 0 },
            { x, y: height },
          ]);
        }
        return d;
      }),
      ...hors.map((y, j) => {
        let d = new Drawing();
        if (item.data.reference_planes.merges) {
          let x = 0;
          for (let i = 0; i < vers.length; i++) {
            const wallAbove =
              item.cache.mergeStore?.hasWallAbove(rows - j, i - 1) ?? true;
            if (wallAbove) {
              d = d.polyline([
                { x, y },
                { x: vers[i], y },
              ]);
              x = vers[i];
            } else {
              x = vers[i];
            }
          }
        } else {
          d = d.polyline([
            { x: 0, y },
            { x: width, y },
          ]);
        }

        return d;
      }),
    ];

    annotations = new Drawing()
      .add(...a)
      .scale(scale, scale)
      .translate(rx - x + xmin * scale, ry - y + ymin * scale)
      .style({ stroke: dragging ? "#AAAAAA" : "#0066E5" });
  }

  let outline;
  if (item.width && item.height) {
    outline = new Drawing()
      .polyface(swf.shape)
      .scale(scale, scale)
      .translate(rx - x, ry - y)
      .style({
        stroke: dragging ? "#AAAAAA" : "#0066E5",
        fill: dragging ? "#AAAAAA" : "#0066E5",
        opacity: 0.1,
      });
  }

  return new Drawing()
    .add(outline, annotations)
    .name(`shapeoverlay_${item.drawing.attachment_id}`);
}

export default shapeOverlay;
